import React from "react";

export default function MachineDescription({ machine }) {
  console.log(machine);
  return (
    <div className="description-wrapper">
      {machine.new_description.map((description) => (
        <p key={description.id}>{description.paragraph}</p>
      ))}
    </div>
  );
}
